import React, { useContext } from "react";
import { CommonService } from "@services";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Box from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";
import PrescriberNotesDialog from "../PrescriberNote/PrescriberNotesDialog";
import { CoverageService } from "@services";
import { PendoService } from "@services";
import { SearchContext } from "../../../contexts/Search";
import { ConfigurationContext } from "../../../contexts/Configuration";
import LoaderWithIcon from "../CommonComponent/LoaderWithIcon";

const PatientPANotificationPopup = ({ selectedPlan, selectedPlanValue, stateId, notificationMessage, buttonText }) => {
  const matchesMobileWidth = useMediaQuery("(max-width:1032px)");
  const { appliedConfiguration } = useContext(ConfigurationContext);
  const { benefitType, productId, productName, indicationName } = useContext(SearchContext);
  const [open, setOpen] = React.useState(false);
  const [prescriberNoteResponse, setPrescriberNoteResponse] = React.useState(null);
  const [additionalPrescriberNoteCriteria, setAdditionalPrescriberNoteCriteria] = React.useState(null);
  const [isMobile, setIsMobile] = React.useState(true);
  const [isLoadingPage, setIsLoadingPage] = React.useState(false);
  const [scrollPosY, setScrollPosY] = React.useState(0);

  let selectedNotificationMessage = CommonService.htmlDecode(
    notificationMessage ??
      "Your doctor may still need to provide more documentation. in order for your insurance to determine if you meet their medical requirements."
  );
  let selectedbuttonText = CommonService.htmlDecode(buttonText ?? "View Requirements");
  const handleClose = () => {
    togglePopupOpen(false);
    document.body.classList.remove("no-scroll");
  };

  const togglePopupOpen = (toggleOpen) => {
    adjustBodyScrollPosition(toggleOpen);
    setOpen(toggleOpen);
  };

    const adjustBodyScrollPosition =(toggleOpen) => {
      //This is to fix an issue on iPhone browsers where a gap shows at the bottom of the screen that the modal background overlay does not cover
      if(toggleOpen) {
        const scrollY = window.scrollY || window.pageYOffset;
        setScrollPosY(scrollY);
        document.body.style.top = `-${scrollY}px`;
        document.body.style.position = "fixed";
        // Force reflow
        void document.body.offsetHeight;
      }
      else {
        document.body.style.position = "";
        document.body.style.top = "";
        // Restore scroll
        window.scrollTo(0, scrollPosY);
      }
    };

  const showNotePopup = async () => {
    setIsLoadingPage(true);
    PendoService.getInstance().trackEvent(
      "View Requirements",
      "showNotePopup",
      selectedPlanValue,
      productId,
      productName,
      indicationName
    );

    const prescriberNoteRequest = {
      ProductId: appliedConfiguration.productId,
      IndicationId: appliedConfiguration.indicationId,
      FormularyId: selectedPlan?.FormularyID || selectedPlan?.majority_FormularyID,
      IsMedical: benefitType?.toLowerCase() != "pharmacy",
      ProjectId: appliedConfiguration.projectId,
      PlanId: selectedPlan?.PlanId,
      ControllerId: selectedPlan?.ControllerId,
      Channel: selectedPlan?.Channel,
      StateId: stateId,
      ResultName:
        benefitType?.toLowerCase() != "pharmacy"
          ? appliedConfiguration.coverageFinderConfiguration.resultName
          : appliedConfiguration.coverageFinderConfiguration.pharmacyResultName,
    };
    const prescriberNoteResponse = await CoverageService.getInstance().getPrescriberNotes(prescriberNoteRequest);
    togglePopupOpen(true);
    if (prescriberNoteResponse != null) {
      setPrescriberNoteResponse([prescriberNoteResponse.prescriberNoteCriteria]);
      setAdditionalPrescriberNoteCriteria([prescriberNoteResponse.additionalPrescriberNoteCriteria]);
      setIsMobile(matchesMobileWidth);
    }
    setIsLoadingPage(false);
  };

  return (
    <>
      {selectedNotificationMessage && selectedNotificationMessage.trim() !== "" ? (
        <Card className="norstella-cf-notificationCard">
          <Box className="norstella-cf-notificationBox">
            <InfoOutlinedIcon className="norstella-cf-notificationIcon" />
            <Typography
              variant="body2"
              dangerouslySetInnerHTML={{ __html: CommonService.sanitizeHTML(selectedNotificationMessage) }}
              className="norstella-cf-notificationMessage"
            />
          </Box>
          <Button onClick={showNotePopup} variant="contained" className="norstella-cf-button">
            <span dangerouslySetInnerHTML={{ __html: CommonService.sanitizeHTML(selectedbuttonText) }} />
          </Button>
        </Card>
      ) : (
        ""
      )}
      {isLoadingPage && (
        <div className="norstella-cf-overlay">
          <LoaderWithIcon></LoaderWithIcon>
        </div>
      )}
      {open && <div onClick={handleClose} part="cfOverlay" className="norstella-cf-overlay"></div>}
      <div className="norstella-cf-divPrescriberNotesDialogOuter">
        <PrescriberNotesDialog
          isOpen={open}
          onClose={handleClose}
          isMobile={isMobile}
          prescriberNoteResponse={prescriberNoteResponse}
          additionalPrescriberNoteCriteria={additionalPrescriberNoteCriteria}
          resultname={selectedPlanValue}
          channelName={selectedPlan?.Channel || ""}
        />
      </div>
    </>
  );
};

export default PatientPANotificationPopup;
